import { render, staticRenderFns } from "./bulkUpload.vue?vue&type=template&id=5fa8c294&"
import script from "./bulkUpload.vue?vue&type=script&lang=js&"
export * from "./bulkUpload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports